import {useEffect, useState} from "react";

export function useAppSettings() {
    const defaultLang = "cn";
    const appVersion = "2.5.0";

    const [lang, setLang] = useState(localStorage.getItem("lang") || defaultLang);
    const [version, setVersion] = useState(localStorage.getItem("appVersion") || appVersion);

    useEffect(() => {
        localStorage.setItem("lang", lang);
    }, [lang]);

    useEffect(() => {
        const storedVersion = localStorage.getItem("appVersion");
        if (storedVersion !== appVersion) {
            setVersion(appVersion);
            localStorage.setItem("appVersion", appVersion);
        }
    }, [appVersion]);

    return {lang, setLang, version};
}
